(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drystang-homepage-alt"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ds-owner').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const markets = root.querySelectorAll('[data-market]');
    const packs = root.querySelectorAll('[data-pack]');
    const reviewLink = root.querySelector('[data-review-link]');
    const destination = root.querySelector('.ds-review__destination');
    let market = 'us';
    let pack = 'single';

    const labels = {
      us: 'Amazon USA',
      ca: 'Amazon Canada',
      single: 'One DryStang Mega',
      bundle: 'Two-pack'
    };

    const updateReview = () => {
      const marketKey = market === 'ca' ? 'Ca' : 'Us';
      const key = `review${marketKey}${pack.charAt(0).toUpperCase()}${pack.slice(1)}`;
      reviewLink.href = root.dataset[key];
      reviewLink.dataset.track = `amazon_review_${market}_${pack}`;
      reviewLink.textContent = root.dataset.reviewLabel;
      destination.textContent = `${labels[market]} \u00b7 ${labels[pack]}`;
    };

    const selectChoice = (buttons, selected) => {
      buttons.forEach((button) => {
        const active = button === selected;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    markets.forEach((button) => button.addEventListener('click', () => {
      market = button.dataset.market;
      selectChoice(markets, button);
      if (document.startViewTransition) document.startViewTransition(updateReview);
      else updateReview();
    }));

    packs.forEach((button) => button.addEventListener('click', () => {
      pack = button.dataset.pack;
      selectChoice(packs, button);
      if (document.startViewTransition) document.startViewTransition(updateReview);
      else updateReview();
    }));

    root.querySelectorAll('[data-track]').forEach((link) => link.addEventListener('click', () => {
      const detail = { event: link.dataset.track, destination: link.href || '' };
      window.dispatchEvent(new CustomEvent('drystang:cta', { detail }));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'drystang_cta', ...detail });
    }));

    const video = root.querySelector('.ds-hero__video');
    const videoToggle = root.querySelector('.ds-video-toggle');
    if (video && videoToggle) {
      videoToggle.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          videoToggle.classList.remove('is-paused');
          videoToggle.setAttribute('aria-label', 'Pause background video');
          videoToggle.setAttribute('aria-pressed', 'false');
        } else {
          video.pause();
          videoToggle.classList.add('is-paused');
          videoToggle.setAttribute('aria-label', 'Play background video');
          videoToggle.setAttribute('aria-pressed', 'true');
        }
      });
    }

    const reveals = root.querySelectorAll('.ds-reveal');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      reveals.forEach((element) => observer.observe(element));
    } else {
      reveals.forEach((element) => element.classList.add('is-visible'));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drystang-owner-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ds-owner').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const markets = root.querySelectorAll('[data-market]');
    const packs = root.querySelectorAll('[data-pack]');
    const reviewLink = root.querySelector('[data-review-link]');
    const destination = root.querySelector('.ds-review__destination');
    let market = 'us';
    let pack = 'single';

    const labels = {
      us: 'Amazon USA',
      ca: 'Amazon Canada',
      single: 'One DryStang Mega',
      bundle: 'Two-pack'
    };

    const updateReview = () => {
      const marketKey = market === 'ca' ? 'Ca' : 'Us';
      const key = `review${marketKey}${pack.charAt(0).toUpperCase()}${pack.slice(1)}`;
      reviewLink.href = root.dataset[key];
      reviewLink.dataset.track = `amazon_review_${market}_${pack}`;
      reviewLink.textContent = root.dataset.reviewLabel;
      destination.textContent = `${labels[market]} \u00b7 ${labels[pack]}`;
    };

    const selectChoice = (buttons, selected) => {
      buttons.forEach((button) => {
        const active = button === selected;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    markets.forEach((button) => button.addEventListener('click', () => {
      market = button.dataset.market;
      selectChoice(markets, button);
      if (document.startViewTransition) document.startViewTransition(updateReview);
      else updateReview();
    }));

    packs.forEach((button) => button.addEventListener('click', () => {
      pack = button.dataset.pack;
      selectChoice(packs, button);
      if (document.startViewTransition) document.startViewTransition(updateReview);
      else updateReview();
    }));

    root.querySelectorAll('[data-track]').forEach((link) => link.addEventListener('click', () => {
      const detail = { event: link.dataset.track, destination: link.href || '' };
      window.dispatchEvent(new CustomEvent('drystang:cta', { detail }));
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'drystang_cta', ...detail });
    }));

    const video = root.querySelector('.ds-hero__video');
    const videoToggle = root.querySelector('.ds-video-toggle');
    if (video && videoToggle) {
      videoToggle.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          videoToggle.classList.remove('is-paused');
          videoToggle.setAttribute('aria-label', 'Pause background video');
          videoToggle.setAttribute('aria-pressed', 'false');
        } else {
          video.pause();
          videoToggle.classList.add('is-paused');
          videoToggle.setAttribute('aria-label', 'Play background video');
          videoToggle.setAttribute('aria-pressed', 'true');
        }
      });
    }

    const reveals = root.querySelectorAll('.ds-reveal');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      reveals.forEach((element) => observer.observe(element));
    } else {
      reveals.forEach((element) => element.classList.add('is-visible'));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
